module.exports = __webpack_public_path__ + "static/media/A3.dd38bf75.jpg";